var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplaceCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 0.875225L17.5055 0.875304C16.3155 0.855544 15.5814 1.80213 15.3217 2.7016C15.3171 2.71756 15.3132 2.73369 15.3098 2.74997L13.6607 10.8314C13.5357 11.2274 13.1743 11.492 12.7677 11.492H4.13722C3.72843 11.492 3.36696 11.2268 3.24729 10.8351L2.20361 4.93937H4.57461C4.91978 4.93937 5.19961 4.65955 5.19961 4.31438C5.19961 3.9692 4.91978 3.68938 4.57461 3.68938H1.45826C1.27344 3.68938 1.0981 3.77117 0.979344 3.91279C0.860592 4.05441 0.810609 4.24133 0.842825 4.42332L2.0222 11.0856C2.02561 11.1049 2.02993 11.124 2.03513 11.1428C2.29824 12.0966 3.16428 12.742 4.13722 12.742H12.7677C13.7441 12.742 14.5955 12.0944 14.8675 11.1589C14.8722 11.1426 14.8763 11.1261 14.8797 11.1094L16.5293 3.02588C16.7095 2.4265 17.0932 2.11745 17.4877 2.12518L17.5 2.1253L18.3333 2.12522C18.6785 2.12519 18.9583 1.84534 18.9583 1.50017C18.9582 1.15499 18.6784 0.875192 18.3332 0.875225Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18352 16.0223C3.18352 15.2169 3.83644 14.564 4.64185 14.564C5.44727 14.564 6.10018 15.2169 6.10018 16.0223C6.10018 16.8277 5.44727 17.4807 4.64185 17.4807C3.83644 17.4807 3.18352 16.8277 3.18352 16.0223Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9407 16.0223C10.9407 15.2169 11.5936 14.564 12.399 14.564C13.2044 14.564 13.8573 15.2169 13.8573 16.0223C13.8573 16.8277 13.2044 17.4807 12.399 17.4807C11.5936 17.4807 10.9407 16.8277 10.9407 16.0223Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceCartIcon);
export default __webpack_public_path__ + "static/media/marketplace_cart_icon.767387e44fc5ba3684020592894824fc.svg";
export { ForwardRef as ReactComponent };